// Must match Glz_Spac_Risk_Liquidation_Summary.label exactly — the backend stores
// the label as written in the Dashboard sheet.
export const WEIGHTED_AVG_DAYS_LABEL =
  "Weighted Average Days to Liquidation (Projected CIT)";

/**
 * Pick one metric out of the liquidation summary payload.
 * Returns null when the row is missing or its value is null, so callers can
 * render an em dash rather than a misleading zero.
 */
export function selectLiquidationMetric(rows, label) {
  if (!Array.isArray(rows)) return null;
  const match = rows.find((row) => row && row.label === label);
  if (!match) return null;
  if (match.value === null || match.value === undefined) return null;
  return Number(match.value);
}
